import React, { Component } from 'react';

class ContainerRight extends Component {
    constructor(props){
        super(props);
        this.state = {
          collRight: [
            {
              id: 1,
              subtitle: "Criteria 5",
              title: "Appeal / Creative Flare of the Literature",
              text: "Its warm illustrations, rhythmic language, and interactive digital format create an emotionally engaging and memorable reading experience.",
            },
            {
              id: 2,
              subtitle: "Criteria 6",
              title: "Individual Written Analysis / Evaluation",
              text: "The project demonstrates reflective understanding of inclusive media practice, linking creative decisions to educational and psychological frameworks.",
            },
          ],
        };
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collRight.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerRight;
